import React, { useState, useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Button, FloatingLabel, Form } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import Factory from '../../components/factory';
import { get } from '../../services/apiController';
import PaginationInPage from '../Pagination';
import { TABLE_DEFAULT_LIMIT } from '../../util/constant';
import Item from '../../components/item';
import { GrDocumentExcel } from 'react-icons/gr';
import moment from 'moment';

const StockDetailsReport = () => {
  const [data, setData] = useState([]);
  const clickToDownload = useRef(null);
  const [state, setState] = useState({
    vendorId: '',
    factoryId: '',
    dateFrom: '',
    dateTo: '',
    itemId: '',
  });
  const [factories, setFactories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const getConsolidatedReport = (download = false) => {
    let url = `/inv/report/stock-details/?factoryId=${state.factoryId}&itemId=${state.itemId}&download=${download}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}`;
    if (!download) {
      url += `&page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}`;
    }
    get(url)
      .then((res) => {
        if (download) {
          clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data.filePath}`;
          setTimeout(() => {
            clickToDownload.current.click();
          }, 500);
        } else {
          setData(res?.data?.data);
          setTotalRecords(res?.data.count);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data.data.message || err?.message);
      });
  };

  function getFactories() {
    try {
      get(`/branches/?type=factory`).then((response) => {
        setFactories(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useEffect(() => {
    if (state.factoryId !== '' && state.dateFrom !== '' && state.dateTo !== '') {
      getConsolidatedReport();
    }
  }, [currentPage]);

  useEffect(() => {
    getFactories();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-3">
            <div className="d-flex" style={{ height: '100%', alignItems: 'center' }}>
              <h4 className="card-title" style={{ fontSize: '16px' }}>
                Stock Details Report | {totalRecords ?? 0}
              </h4>
            </div>
          </div>
          <div className="card-header-actions col-9 d-flex justify-content-end">
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel label="Factory" className="mb-3">
                <Factory
                  factory={state.factoryId}
                  onChange={(e) => {
                    setState({ ...state, factoryId: e.target.value });
                  }}
                  factories={factories}
                  label="factory"
                  name="factoryId"
                />
              </FloatingLabel>
              <Item
                itemId={state.itemId}
                name="itemId"
                onChange={(itemId) => {
                  setState({ ...state, itemId });
                }}
              />
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="From Date">
                <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
              </FloatingLabel>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="To Date">
                <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
              </FloatingLabel>
            </div>
            <div className="d-flex" style={{ maxWidth: '200px', flexDirection: 'column', alignItems: 'center' }}>
              <Button onClick={() => getConsolidatedReport()} type="submit" className="btn app-btn-default dark-color">
                Apply
              </Button>
              <GrDocumentExcel
                title="Download rejected items report"
                className="react-icons green mt-2"
                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                onClick={() => getConsolidatedReport(true)}
              />
              <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Item</th>
                    <th>Unit</th>
                    <th>Factory</th>
                    <th>Opening Balance</th>
                    <th>Quantity Received</th>
                    <th>Total Quantity</th>
                    <th>Kitchen Indents</th>
                    <th>Closing Stock</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => {
                    return (
                      <tr key={item.id}>
                        <td>{moment(item.grnDate).format('DD/MM/YYYY')}</td>
                        <td>{item.itemName}</td>
                        <td>{item.unit}</td>
                        <td>{item.branchName}</td>
                        {/* Opening Balance for next day */}
                        <td>{item.openingBalance}</td>
                        <td>{item.inQty}</td>
                        <td>{item.totalQuantity}</td>
                        <td>{item.outQty}</td>
                        <td>{item.closingBalance}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
              <PaginationInPage
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalRecords={totalRecords}
                TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StockDetailsReport;
